import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import type { GenericDisplayProps } from "./DisplayComponent"

type Props = GenericDisplayProps<boolean>

const BooleanDisplay: ReactiveComponent<Props> = (props) => {
	function getText() {
		if (props.value === null) {
			return ""
		}
		return props.value ? "Yes" : "No"
	}

	return () => getText()
}

export default defineComponent(BooleanDisplay, inferProps<Props>())
